export class PageSettings {
    Start: number;
    End: number = 0;
    PageSize: number = 10;
    SearchValue: string="";
    Orderby: string = "";
    Dir: string = ""
}


